<template>
  <div class="pagination">
    <ul class="pagination__wrapper" v-if="totalPages > 1">
      <li class="pagination__item">
        <button
          type="button"
          @click="onClickPreviousPage"
          :disabled="isInFirstPage"
          aria-label="Poprzednia strona"
        >
          Poprzednia
        </button>
      </li>

      <li v-for="page in pages" :key="page.name" class="pagination__item">
        <button
          type="button"
          @click="onClickPage(page.name)"
          :disabled="page.isDisabled"
          :class="{ active: isPageActive(page.name) }"
          :aria-label="`Strona ${page.name}`"

        >
          {{ page.name }}
        </button>
      </li>

      <li class="pagination__item">
        <button
          type="button"
          @click="onClickNextPage"
          :disabled="isInLastPage"
          aria-label="Następna strona"
        >
          Następna
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'pagination',
    props: {
      maxVisibleButtons: {
        type: Number,
        required: false,
        default: 3,
      },
      totalPages: {
        type: Number,
        required: true,
      },
      perPage: {
        type: Number,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
    },

    computed: {
      startPage() {
        if (this.currentPage <= 1) {
          return 1;
        }

        if (this.currentPage >= this.totalPages) {
          return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
        }

        return this.currentPage - 1;
      },

      endPage() {
        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
      },

      pages() {
        const range = [];

        for (let i = this.startPage; i <= this.endPage; i++) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage,
          });
        }

        return range;
      },

      isInFirstPage() {
        return this.currentPage === 1;
      },

      isInLastPage() {
        return this.currentPage === this.totalPages;
      },
    },
    methods: {
      onClickPreviousPage() {
        this.$emit('pagechanged', this.currentPage - 1);
      },

      onClickPage(page) {
        this.$emit('pagechanged', page);
      },

      onClickNextPage() {
        this.$emit('pagechanged', this.currentPage + 1);
      },

      isPageActive(page) {
        return this.currentPage === page;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;

    &__wrapper {
      list-style-type: none;
      max-width: 350px;
      margin: 0 auto;
    }

    &__item {
      display: inline-block;
      margin: 8px;
      button {
        @include fontSize(18px);
        text-transform: uppercase;
        border: 0;
        background: none;
        outline: 0;

        &.active,
        &:not([disabled]):hover {
          color: $color--red;
          cursor: pointer;
        }
      }
    }
  }
</style>
